var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.symbol.async-iterator.js
// module id = 467
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33